module.exports = __webpack_public_path__ + "img/ncdc-logo.5c3c57c5.png";